// extracted by mini-css-extract-plugin
export default {"footerItem":"footerItem__KG9+3","footer":"footer__DGBa9","footerLogo":"footerLogo__UaXkp","footerText":"footerText__psw1X"};